var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtrudedBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7969 12.5312H1.20312V3.46875L2.5625 2.10938L8 1.20312L13.4375 2.10938L14.7969 3.46875V12.5312Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 12.5312C14.75 12.7123 14.6539 12.9446 14.3486 13.2154C14.0437 13.4856 13.5742 13.7518 12.951 13.9855C11.7083 14.4515 9.95795 14.75 8 14.75C6.04205 14.75 4.29174 14.4515 3.04904 13.9855C2.42584 13.7518 1.95625 13.4856 1.65144 13.2154C1.34605 12.9446 1.25 12.7123 1.25 12.5312C1.25 12.3502 1.34605 12.1179 1.65144 11.8471C1.95625 11.5769 2.42584 11.3107 3.04904 11.077C4.29174 10.611 6.04205 10.3125 8 10.3125C9.95795 10.3125 11.7083 10.611 12.951 11.077C13.5742 11.3107 14.0437 11.5769 14.3486 11.8471C14.6539 12.1179 14.75 12.3502 14.75 12.5312Z",
    fill: "#00C2FF",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3.46875C14.75 3.64979 14.6539 3.88212 14.3486 4.15288C14.0437 4.42312 13.5742 4.68933 12.951 4.92303C11.7083 5.38904 9.95795 5.6875 8 5.6875C6.04205 5.6875 4.29174 5.38904 3.04904 4.92303C2.42584 4.68933 1.95625 4.42312 1.65144 4.15288C1.34605 3.88212 1.25 3.64979 1.25 3.46875C1.25 3.28771 1.34605 3.05538 1.65144 2.78462C1.95625 2.51438 2.42584 2.24817 3.04904 2.01447C4.29174 1.54846 6.04205 1.25 8 1.25C9.95795 1.25 11.7083 1.54846 12.951 2.01447C13.5742 2.24817 14.0437 2.51438 14.3486 2.78462C14.6539 3.05538 14.75 3.28771 14.75 3.46875Z",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20312 3.46875V12.5312",
    stroke: "#222627",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7969 3.46875V12.5312",
    stroke: "#222627",
    strokeDasharray: "1 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrudedBody);
export default __webpack_public_path__ + "static/media/extruded-body.6485bea6c55238bc2c625aa66c7a4ebe.svg";
export { ForwardRef as ReactComponent };